import React, {Component} from "react";
import {connect} from "react-redux";
import {verifyToken} from "../actions/portalActions";

class PortalVerificationCallback extends Component {
    componentDidMount() {
        this.props.verifyToken(this.props.params.verificationToken);
    }

    render() {
        if (!this.props.verification) {
            return <div> <h1 style={{ color: "#28313E", fontWeight: "bold", margin: 0, padding: 10, fontSize: "1em", borderBottom: "1px solid #ddd", backgroundColor: "#eee"}}>
                         Verifying Link </h1>
                       <div style={{ padding: ".5em" }}> Verifying the link in your email... </div>
                   </div>;
        }
        if (this.props.verification.verified) {
            return <div> <h1 style={{ color: "#28313E", fontWeight: "bold", margin: 0, padding: 10, fontSize: "1em", borderBottom: "1px solid #ddd", backgroundColor: "#eee"}}>
                         Verifying Link </h1>
                       <div style={{ padding: ".5em" }}> Your email link has been successfully verified. </div>
                   </div>;
        }
        return <div> <h1 style={{ color: "#28313E", fontWeight: "bold", margin: 0, padding: 10, fontSize: "1em", borderBottom: "1px solid #ddd", backgroundColor: "#eee"}}>
                         Link Expired </h1>
                     <div style={{ padding: ".5em" }}> Unfortunately this link has expired. </div>
                     <div style={{ padding: ".5em" }}> Please click <a href="#/verify-email">here</a> to verify your email address so we can show you your disclosures. </div>
               </div>;
    }
}
PortalVerificationCallback.propTypes = {
    verification: React.PropTypes.shape({
        verified: React.PropTypes.bool.isRequired,
        error: React.PropTypes.shape({
            code: React.PropTypes.number.isRequired,
            message: React.PropTypes.string
        })
    })
};

export const mapDispatchToProps = (dispatch, ownProps) => ({
    verifyToken: (token) => dispatch(verifyToken(token))
});

export const mapStateToProps = (state) => ({
    verification: state.portal.verificationTokenExchange
});

export default connect(mapStateToProps, mapDispatchToProps)(PortalVerificationCallback);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/portal/components/PortalVerificationCallback.js
 **/